module.exports = __webpack_public_path__ + "img/banner.3d752b39.png";